<template>
  <tr>
    <td
      :colspan="colspan"
      :style="{height: `${height}px`}"
    ></td>
  </tr>
</template>

<script>
import Mixin from "./Mixin";

export default {
  name: "HeightHelp",
  mixins: [Mixin],
  props: {
    height: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
